import './Logo.styled.scss'

export const Logo = () => (
  <div className="logoWrapper" data-testid="logo">
    <p className="robo">ROBO</p>
    <div className="learnWrapper">
      <p className="learn">LEARN</p>
    </div>
  </div>
)
